import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    sectionTitle: {
      margin: '60px 0 32px',
      flex: 1,
    },
    headerContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    maintenanceIcon: {
      fontSize: 35,
      marginLeft: 15,
      animation: '$maintenanceIcon 1s linear infinite',
    },
    '@keyframes maintenanceIcon': {
      '50%': {
        opacity: 0,
      },
    },
    maintenanceWarn: { display: 'flex', alignItems: 'center' },
    maintenanceText: {
      fontWeight: 500,
      marginLeft: 6,
      color: palette.darkRed,
      fontSize: 14,
    },
    clientHead: { width: '80%' },
    red: {
      border: `1px solid ${palette.error.light}`,
      background: palette.error.main,
      color: palette.error.contrastText,
      padding: '8px 16px',
      fontSize: '12px',
      height: 30,

      '&:hover': {
        backgroundColor: palette.error.dark,
      },
    },
  });
